import { render, staticRenderFns } from "./Tints.vue?vue&type=template&id=d4f7216a&"
import script from "./Tints.vue?vue&type=script&lang=js&"
export * from "./Tints.vue?vue&type=script&lang=js&"
import style0 from "./Tints.vue?vue&type=style&index=0&id=d4f7216a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports